import {
  findAuthorizedLogitechWheel,
  LOGITECH_DEVICE_FILTERS,
} from "../../utils/controller/logitech_g923_device";

// 로그인 버튼(사용자 제스처) 컨텍스트에서 콕핏 입출력 장치 권한을 일괄 사전 획득한다.
// 모든 요청은 best-effort — 거부/미지원이어도 로그인 흐름을 막지 않는다.
// (다중 모니터 자동 점유는 호출 측에서 externalDisplayManager.autoOpenAvailableDisplays 로 수행.)
export async function acquireCockpitDevicePermissions(): Promise<void> {
  // 1) 마이크 — 콕핏↔차량 음성. 권한만 받고 트랙은 즉시 정지(실사용은 communicator 가 다시 획득).
  try {
    const stream = await navigator.mediaDevices?.getUserMedia({ audio: true });
    stream?.getTracks().forEach((track) => track.stop());
  } catch {
    // 마이크 거부/미지원 — 무시(음성 없이 진행).
  }

  // 2) 게이밍 휠(WebHID) — 첫 1회 선택 팝업 필요. 이미 승인된 휠이 있으면 팝업 생략.
  try {
    if (navigator.hid) {
      const existing = (await navigator.hid.getDevices?.()) ?? [];
      const alreadyAuthorized = findAuthorizedLogitechWheel(existing);
      if (!alreadyAuthorized) {
        await navigator.hid.requestDevice({ filters: LOGITECH_DEVICE_FILTERS });
      }
    }
  } catch {
    // 휠 거부/미지원 — 무시(키보드/게임패드로 대체).
  }
}
